export function bit(active: boolean) {
  return active ? 1 : 0
}
